import * as React from "react";
import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import * as SelectPrimitive from "@radix-ui/react-select";
import { Check, X } from "lucide-react";

// Select customizado para o tema escuro do Brave Access
// Suporta `clearable`: quando true, renderiza um X clicável dentro do trigger
// que limpa o valor (chama onValueChange("")). Útil para campos opcionais.
const BraveSelect = React.forwardRef(({
  value,
  onValueChange,
  placeholder = "Selecione...",
  options = [],
  className = "",
  clearable = false,
  ...props
}, ref) => {
  // Filtrar opções com value vazio (usar placeholder para isso)
  const validOptions = options.filter(opt => opt.value !== "" && opt.value !== null && opt.value !== undefined);

  // Garantir que o valor é sempre string para comparação correta
  const stringValue = value ? String(value) : "";

  const handleClear = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onValueChange) onValueChange("");
  };

  return (
    <Select value={stringValue} onValueChange={onValueChange} {...props}>
      <SelectTrigger
        ref={ref}
        {...props}
        className={`relative h-10 bg-white/10 border-brand-ice/20 text-brand-ice focus:ring-brand-light/30 focus:border-brand-light ${clearable && stringValue ? "pr-14" : ""} ${className}`}
      >
        <SelectValue placeholder={placeholder} />
        {clearable && stringValue && (
          <button
            type="button"
            onClick={handleClear}
            onPointerDown={(e) => e.stopPropagation()}
            className="absolute right-8 top-1/2 -translate-y-1/2 p-0.5 rounded hover:bg-white/15 text-brand-ice/60 hover:text-brand-ice transition-colors"
            data-testid="brave-select-clear-btn"
            aria-label="Limpar seleção"
            title="Limpar seleção"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </SelectTrigger>
      <SelectContent className="bg-[#1a2744] border-brand-ice/20 shadow-xl z-[100]">
        {validOptions.map((opt) => (
          <SelectPrimitive.Item
            key={opt.value}
            value={String(opt.value)}
            className="relative flex w-full cursor-pointer select-none items-center rounded-sm py-2 pl-3 pr-8 text-sm outline-none hover:bg-white/20 focus:bg-white/20 data-[highlighted]:bg-white/20"
            style={{ color: 'white' }}
          >
            <span className="absolute right-2 flex h-3.5 w-3.5 items-center justify-center">
              <SelectPrimitive.ItemIndicator>
                <Check className="h-4 w-4" style={{ color: 'white' }} />
              </SelectPrimitive.ItemIndicator>
            </span>
            <SelectPrimitive.ItemText>
              <span style={{ color: 'white' }}>{opt.label}</span>
            </SelectPrimitive.ItemText>
          </SelectPrimitive.Item>
        ))}
      </SelectContent>
    </Select>
  );
});

BraveSelect.displayName = "BraveSelect";

export { BraveSelect };
